export default __webpack_public_path__ + "static/media/icon-card-metrics.ca835b1d.svg";